import { createSelector } from 'reselect';
import _ from 'lodash';

const ProductManagement = {
    createProductDataSelector: () => createSelector([
        (state) => state.productManagement.getProduct.data,
    ], ProductManagement.productDataFormatter),
    createProductDataCreateErrorSelector: () => createSelector([
        (state) => state.productManagement.create.errors,
    ], (errors) => {
        if (!_.isEmpty(errors)) {
            return {
                code: errors.code,
                message: errors.message,
                ...ProductManagement.productDataFormatter(errors),
                ...{ ...errors?.non_field_errors?.message && { messageError: errors?.non_field_errors?.message } },
            };
        }
        return {};
    }),
    productDataFormatter: (result) => {
        if (!_.isEmpty(result)) {
            return {
                id: result.id,
                mediaType: result.media_type,
                productName: result.name,
                productNameEN: result?.name_en,
                productDescription: result.description,
                productDescriptionEN: result?.description_en,
                productAvailableProduct: result.available,
                purchaseLink: result.purchase_link,
                businessContact: result.business_contact,
                documentRequestReception: result.document_link,
                survey: result.survey_link,
                hasOutsideLink: result.has_outside_link,
                bulletin: result.outside2_link,
                externalLink3: result.outside3_link,
                mediaFileSource: result.media,
                documentFileSource: result.document,
                media_status: result.media_status,
                businessCard: result.business_card,
                businessCardInfo: result.business_card_info,
                price: result.price,
                isWaitingOrder: result.is_in_order_waiting,
            };
        }
        return {};
    },
};

export default ProductManagement;
